import { Component, Injector, ViewChild, ElementRef, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import type { OnInit, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { timer } from 'rxjs';
import { IonButton, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// import { ViewBasePage } from '@shared/pages';
import { BasePage } from '@shared/common';
import {
    AuthService,
    LocalStorageService,
} from '@shared/services';
import type { TLoginCredentials } from '@shared/models';
type TLoginState = {
    loginText: string;
    version: string;
};

@Component({
    'selector': 'app-loginCard',
    'templateUrl': './loginCard.component.html',
    'styleUrls': ['./loginCard.component.css'],
    'standalone': true,
    'imports': [ IonicModule, CommonModule, FormsModule ]
})
//export class LoginCardComponent extends ViewBasePage implements OnInit {
export class LoginCardComponent extends BasePage implements OnInit, AfterViewInit {
    @Input() public appSource: string;
    @Output() public userCredentialEvent = new EventEmitter<TLoginCredentials>();
    @ViewChild('password', { read: ElementRef }) public passwordRef: ElementRef;
    @ViewChild('loginButton') private loginButton: IonButton;
    @ViewChild('loginForm') private loginForm: NgForm;

    public passwordVisible = false;
    public user: TLoginCredentials = {
        email: '1@2.com',
        password: '2',
        userUid: '3'
    };

    public vm: TLoginState = {
        loginText: '',
        version: ''
    };
    public submitted = false;

    constructor(private authService: AuthService, private localStorageService: LocalStorageService,
        private cdr: ChangeDetectorRef, injector: Injector) {
        super(injector);
    }

    public ngAfterViewInit(): void {
        // Simulate a click event on the page to activate the form
        timer(200).subscribe(() => {
            const clickEvent = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': true
            });
            document.body.dispatchEvent(clickEvent);
        });
    }

    public override async ngOnInit(): Promise<void> {
        this.user = await this.getDefaultLoginCreds();
        // this.vm.loginText = 'Login';

        // Set the initial connection state of the Login button.
        // This code will not work if it's not in a timer block!
        timer(50).subscribe(() => {
            const isOnline = this.connectivityService.isOnline();
            this.showInternetConnectionState(isOnline);
        });

        // When the internet connection state changes then enable/disable the login button.
        // this.connectivityService.monitor().subscribe(isConnected => {
        //     this.showInternetConnectionState(isConnected);
        // });
    }

    // Toggle the password visibility.
    public onEyeClick(): void {
        this.passwordVisible = !this.passwordVisible;
        this.passwordRef.nativeElement.setAttribute('type', this.passwordVisible ? 'text' : 'password');
    }

    // Get the default login credentials from the local storage.
    private async getDefaultLoginCreds(): Promise<TLoginCredentials> {
        const emailKey = this.appSource + '_shuttleNomixLoginEmail';
        const passwordKey = this.appSource + '_shuttleNomixLoginPassword';

        try {
            const user: TLoginCredentials = {};
            user.email = await this.localStorageService.get(emailKey);
            user.password = await this.localStorageService.get(passwordKey);
            user.userUid = '';
            return user;
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
            return { email: '', password: '', userUid: '' };
        }
    }

    // Authenticate the email and password and emit the userUid.
    public async onLoginClick(form: NgForm): Promise<void> {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        const { email, password } = this.user;
        if (!email || !password) {
            await this.uxHelperService.showAlert('Error', 'Please enter both email and password');
            return;
        }
        try {
            await this.uxHelperService.showSpinner('Logging you in.');
            const cred = await this.authService.login(email, password);
            await this.uxHelperService.hideSpinner();
            this.userCredentialEvent.emit(cred);
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    // To test, toggle Airplane mode on and off.
    private showInternetConnectionState(isConnected: boolean) {
        try {
            this.vm.loginText = isConnected ? 'Login' : 'No Internet Available';
            this.loginButton.disabled = !isConnected;
        } catch (err) {
            // console.error('err = ', err);
        }
    }
}
